<template>
	<div>
		<h4 v-if="form.formSchema.sections.length > 0">Sekcje formularza</h4>
		<ol style="background-color: #F1F1F1">
			<li v-for="(section, index) in form.formSchema.sections" v-bind:key="index" :class="selected(index)">
				{{ section.name }}
				<v-icon @click="openRenameModal(index)" flat>
					create
				</v-icon>

				<v-icon @click="moveSectionUp(index)" flat v-if="isNotFirst(index)">
					arrow_upward
				</v-icon>

				<v-icon @click="moveSectionDown(index)" flat
					v-if="isNotLast(index)">
					arrow_downward
				</v-icon>
				<v-icon @click="selectSection(index)">build</v-icon>
				<v-btn @click="renderForm(index)">Podgląd</v-btn>
				<v-icon @click="removeSection(index)" flat>
					close
				</v-icon>
			</li>
		</ol>
		<EditNameModal ref="editNameModal" v-on:rename="renameSection"/>
	</div>
</template>
<script>
	import EditNameModal from "../EditNameModal";

	export default {
		name: "SectionList",
		components: {EditNameModal},
		props: {
			value: Object,
		},

		watch: {
			form: {
				handler() {
					this.$emit("input", this.form);
				}
				,
				deep: true,
			},
		},

		data() {
			return {
				form: this.value,
			};
		},

		methods: {

			openRenameModal(index) {
				let currentSectionName = this.form.formSchema.sections[index].name;
				this.$refs.editNameModal.openModal(currentSectionName, index);
			},

			renameSection(event) {
				this.form.formSchema.sections[event.index].name = event.name;
			},

			selected(index) {
				if (index === this.form.selected.sectionIndex) {
					return "success";
				}
			},

			isNotLast(index) {
				return this.form.formSchema.sections.length > 0 && index !== this.form.formSchema.sections.length - 1;
			},

			isNotFirst(index) {
				return index !== 0;
			},

			moveSectionUp(index) {
				this.swapTwoArrayElements(this.form.formSchema.sections, index - 1, index);
				this.clearIndexes();
			},

			moveSectionDown(index) {
				this.swapTwoArrayElements(this.form.formSchema.sections, index + 1, index);
				this.form.selected.sectionIndex = undefined;
				this.clearIndexes();
			},

			selectSection(index) {
				this.clearIndexes();
				this.form.selected.sectionIndex = index;
				this.$forceUpdate();
			},

			removeSection(index) {
				if (this.form.selected.sectionIndex === index) {
					this.clearIndexes();
				}
				this.form.formSchema.sections.splice(index, 1);
				this.clearIndexes();
			},

			clearIndexes() {
				this.form.selected.sectionIndex = null;
				this.form.selected.groupIndex = null;
				this.form.selected.fieldIndex = null;
			},

			renderForm(index) {
				this.clearIndexes();
				this.form.selected.sectionIndex = index;
				this.$emit("renderIndex", index);
			},

			swapTwoArrayElements(array, index1, index2) {
				// swap na dwóch elementach tablicy w ES6
				array = [array[index1], array[index2]] = [array[index2], array[index1]];
				this.$forceUpdate();
			},
		},
	};
</script>

<style scoped>
	.theme--dark .ol {
		background-color: #1b1B1B;
	}
</style>
